import { Tool, type ToolArgsWithController } from '@aha-app/aha-editor-v2';
import {
  createWhiteboardRecord,
  insertWhiteboard,
} from 'components/aha_editor_field_v2/WhiteboardUtils';

class ToolInsertNewWhiteboard extends Tool {
  static toolName = 'New whiteboard';
  static iconClass = 'fa-regular fa-shapes';

  static available({ controller }: ToolArgsWithController): boolean {
    return Boolean(controller.ahaEditor.hasPlugin('embeddedWhiteboard'));
  }

  static action({ editor, controller }: ToolArgsWithController) {
    insertWhiteboard(
      { editor },
      createWhiteboardRecord({
        objectType: controller.objectType,
        objectId: controller.objectId,
        baseURL: controller.baseURL,
        getSharingToken: controller.getSharingToken,
      }).then(res => res.whiteboard.id)
    );
  }
}

export default ToolInsertNewWhiteboard;
